import React, { Fragment, useRef, useState, useEffect } from "react";
import _ from "lodash";
import EditRegisterFields from "./EditRegisterFields";
import formFields from "./formFields";
import { db } from "../../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

export const EditForm = ({
  onChange,
  initailValues,
  onEdit,
  fileNames,
  defaultfiles,
  onViewFile,
}) => {
  const inputRef = useRef({});
  const [salesOptions, setSalesOptions] = useState([]);

  useEffect(() => {
    // Load sales representatives
    const loadSalesReps = async () => {
      try {
        const salesQuery = query(
          collection(db, "sales"),
          where("status", "==", "Available")
        );
        const salesSnapshot = await getDocs(salesQuery);
        const salesList = salesSnapshot.docs.map((doc) => doc.data().name.trim());
        setSalesOptions(salesList);
      } catch (error) {
        console.error("Error loading sales representatives:", error);
      }
    };

    loadSalesReps();
  }, []);

  const renderFields = () => {
    return _.map(formFields, ({ label, name, type, options, required }) => {
      return (
        <EditRegisterFields
          name={name}
          label={label}
          type={type}
          value={inputRef.current[name]}
          options={name === "sales" ? salesOptions : options}
          required={required}
          initailValue={
            type !== "date"
              ? initailValues[name]
              : initailValues[name]
              ? initailValues[name].toDate().toLocaleDateString("en-CA")
              : ""
          }
          fileNames={fileNames}
          defaultfiles={defaultfiles}
          disabled={name === "serialNumber" ? true : onEdit}
          onChange={onChange(name)}
          onViewFile={onViewFile}
        />
      );
    });
  };

  return <Fragment>{renderFields()}</Fragment>;
};
